(function () {
  'use strict';

  angular.module('sempraWebapp').factory('applicationStore', applicationStoreFactory);

  /** @ngInject */
  function applicationStoreFactory (dispatcher, EventEmitter, ActionTypesEnum, $translate) {
    var ApplicationStore = new EventEmitter(),
      loaderImmutable = Immutable.fromJS({
        loaderVisible: false,
        hasErrors : false,
        errorName : $translate.instant('DEFAULT_ERROR_NAME'),
        errorDescription : $translate.instant('DEFAULT_ERROR_DESCRIPTION'),
        errorPageMsg : '',
        toasterMsg : ''
      });

    ApplicationStore.events = Object.freeze({
      CHANGE: 'change',
      LOADER_CHANGE: 'loader_change',
      ERROR_STATE_CHANGE : 'error_state_change',
      ERROR_PAGE_STATE_CHANGE : 'error_page_state_change',
      TOAST_CHANGE : 'toast_change'
    });

    ApplicationStore.get = function () {
      return loaderImmutable.toJSON();
    };

    ApplicationStore.dispatchToken = dispatcher.register(function (actionData) {
      switch (actionData.type) {
        case ActionTypesEnum.SHOW_LOADER:
          loaderImmutable = loaderImmutable.set('loaderVisible', true);
          ApplicationStore.emit(ApplicationStore.events.LOADER_CHANGE, loaderImmutable.get('loaderVisible'));
          break;
        case ActionTypesEnum.HIDE_LOADER:
          loaderImmutable = loaderImmutable.set('loaderVisible', false);
          ApplicationStore.emit(ApplicationStore.events.LOADER_CHANGE, loaderImmutable.get('loaderVisible'));
          break;
        case ActionTypesEnum.SHOW_ERROR_MSG:
          // show error msg and emmit
          loaderImmutable = loaderImmutable.set('hasErrors', true);
          loaderImmutable = loaderImmutable.set('errorName', actionData.payload.errorDescription.error);
          loaderImmutable = loaderImmutable.set('errorDescription', actionData.payload.errorDescription.message);
          ApplicationStore.emit(ApplicationStore.events.ERROR_STATE_CHANGE, loaderImmutable.get('hasErrors'), loaderImmutable.get('errorName'), loaderImmutable.get('errorDescription'));
          break;
        case ActionTypesEnum.HIDE_ERROR_MSG:
          // hide error msg 
          loaderImmutable = loaderImmutable.set('hasErrors', false);
          loaderImmutable = loaderImmutable.set('errorName', '');
          loaderImmutable = loaderImmutable.set('errorDescription', '');
          ApplicationStore.emit(ApplicationStore.events.ERROR_STATE_CHANGE, loaderImmutable.get('hasErrors'), loaderImmutable.get('errorName'), loaderImmutable.get('errorDescription'));
          break;
        case ActionTypesEnum.SHOW_ERROR_PAGE:
          // redirect to error page
          loaderImmutable = loaderImmutable.set('errorPageMsg', actionData.payload.errorPageMsg);
          ApplicationStore.emit(ApplicationStore.events.ERROR_PAGE_STATE_CHANGE, loaderImmutable.get('errorPageMsg'));
          break;
        case ActionTypesEnum.HIDE_ERROR_PAGE:
          // window go back
          ApplicationStore.emit(ApplicationStore.events.ERROR_PAGE_STATE_CHANGE, loaderImmutable.get('errorPageMsg'));
          break;
        case ActionTypesEnum.SHOW_TOASTER_MSG:
          // show toaster
          loaderImmutable = loaderImmutable.set('toasterMsg', actionData.payload.message);
          ApplicationStore.emit(ApplicationStore.events.TOAST_CHANGE, loaderImmutable.get('toasterMsg'));
          break;
      }
    });

    return ApplicationStore;
  }
})();
